import * as React from 'react';

export function RecurringIcon({
  width,
  height,
  stroke,
  fill,
}: {
  width: number;
  height: number;
  stroke?: string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={11.1816} cy={11.0078} r={10.5} fill={fill} stroke={stroke} />
      <path
        d="M16.182 11.008c0 2.76-2.24 5-5 5s-4.445-2.78-4.445-2.78m0 0h2.26m-2.26 0v2.5m-.555-4.72c0-2.76 2.22-5 5-5 3.335 0 5 2.78 5 2.78m0 0v-2.5m0 2.5h-2.22"
        stroke={stroke}
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
